export default {
	zh_TW: {
		gameNone: '請選擇遊戲',
		serverNone: '請選擇伺服器',
		roleNone: '請選擇角色',
		redeemNone: '請輸入序列號',
		verfiedNone: '請輸入驗證碼',
		invalidRedeem: '序列號只能是數字加英文',
		invalidVerfied: '驗證碼只能是数字加英文',
		login: '請先登錄',
		varError: '参数错误',
		noRole: '暫無角色',
		verfiedError: '驗證碼不正確',
		gameMaintain: '遊戲維護中，無法兌換獎勵。',
		serverMaintain: '服務器維護中，無法兌換獎勵。',
		roleUnexist: '角色不存在',
		gameWrong: '虛寶號遊戲不符！',
		toMany: '領取次數過多',
		sendFail: '發送失敗',
		retry: '請使用角色登入遊戲后，再嘗試',
		failRetry: '發送失敗，請使用角色登入遊戲后，再嘗試',
		used: '序號無法使用',
		expired: '序號已過期',
		unexist: '序號已使用或不存在',
		success: '發送成功',
		useMax: '該禮包碼使用次數已達上限',
	},

	init: function(lang) {
		if (!!lang) {
			this.lang = lang;
		} else {
			this.lang = 'zh_TW';
		}
	},
	get: function(key) {
		var lang = this.lang;
		return this[lang][key];
	}
};
